import { Component, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ModalComponent, ProgressComponent } from '@tecalisdev/infinity';
import { IOperationBalanceItem } from '../../../panel/models/panel.models';
import { itemBalancePercent } from '../../utils/operation-balance.util';

@Component({
	selector: 'app-operation-balance-modal',
	imports: [ModalComponent, ProgressComponent, TranslatePipe],
	templateUrl: './operation-balance-modal.component.html',
	styleUrl: './operation-balance-modal.component.scss',
})
export class OperationBalanceModalComponent {
	public readonly isVisible = input(false);
	/** @deprecated Título fijo i18n «Identity prepago»; se mantiene por compatibilidad del binding. */
	public readonly packName = input<string | null>(null);
	public readonly items = input<IOperationBalanceItem[]>([]);
	public readonly closeEvent = output<void>();

	public purchasedOf(item: IOperationBalanceItem): number {
		return Math.max(0, Math.trunc(item.purchased));
	}

	/** Consumo acotado a purchased (misma regla que el sidenav). */
	public consumedOf(item: IOperationBalanceItem): number {
		const purchased = this.purchasedOf(item);
		const fromOp = Math.max(0, Math.trunc(item.consumed ?? 0));
		if (fromOp > 0) {
			return Math.min(fromOp, purchased);
		}
		const remaining = Math.max(0, Math.min(Math.trunc(item.remaining), purchased));
		return Math.max(0, purchased - remaining);
	}

	public percentOf(item: IOperationBalanceItem): number {
		return itemBalancePercent(item.purchased, item.remaining, item.consumed);
	}

	public onClose(): void {
		this.closeEvent.emit();
	}
}
